import { styled } from "@mui/material";
const StyledTag = styled("div")(({ interactive, theme, color, disabled, size, type, onClose }) => ({
  minWidth: "20px",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: "fit-content",
  color: theme.palette.secondary[900],
  border: `1px solid ${theme.palette.secondary[500]}`,
  backgroundColor: theme.palette.secondary[200],
  height: "18px",
  padding: "0 6px",
  display: "flex",
  alignItems: "center",
  gap: "3px",
  boxSizing: "border-box",
  cursor: interactive ? "pointer" : "default",
  ...color === "grey" && {
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[300]}`,
    color: theme.palette.grey[800],
    svg: {
      color: theme.palette.grey[400]
    }
  },
  ...onClose && {
    paddingRight: "3px"
  },
  ...size === "xxs" && {
    padding: "0 3px",
    ...onClose && {
      paddingRight: "0px"
    }
  },
  ...size === "sm" && {
    height: "24px",
    ...type === "circle" && {
      height: "30px",
      padding: "0 12px",
      ...onClose && {
        paddingRight: "9px"
      }
    }
  },
  ...type === "circle" && {
    borderRadius: "15px",
    border: "none",
    backgroundColor: theme.palette.white.main,
    color: theme.palette.grey[800],
    svg: {
      color: theme.palette.grey[400]
    }
  },
  ...disabled && {
    pointerEvents: "none",
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[400],
    ...type === "circle" && {
      border: "none"
    }
  }
})), StyledIconContainer = styled("button")(({ theme }) => ({
  color: theme.palette.grey[400],
  cursor: "pointer",
  width: "18px",
  height: "18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "none",
  padding: "0",
  backgroundColor: "transparent"
}));
export {
  StyledIconContainer,
  StyledTag
};
//# sourceMappingURL=styles.js.map
